import React from 'react';
import styled from 'styled-components';
import { Button } from '@avangard/ui/core';

import { StudentSubjectResultsDrawer } from '@modules/students/organisms';

import type { StudentSubjectResultsDrawerProps } from '@modules/students/organisms';

type TestingStudentResultsProps = Omit<StudentSubjectResultsDrawerProps, 'open' | 'onClose'>;

const Root = styled.div`
    margin-top: 5px;
`;

const TestingResults = (props: TestingStudentResultsProps) => {
    const [openDrawerResults, setOpenDrawerResults] = React.useState(false);

    const handleOpenResults = React.useCallback(() => {
        setOpenDrawerResults(true);
    }, []);

    const handleCloseResults = React.useCallback(() => {
        setOpenDrawerResults(false);
    }, []);

    return (
        <Root>
            <Button variant='text' onClick={handleOpenResults}>
                Посмотреть результаты
            </Button>

            <StudentSubjectResultsDrawer
                {...props}
                open={openDrawerResults}
                onClose={handleCloseResults}
            />
        </Root>
    );
};

export { TestingResults };
